import React from 'react';
import { graphql, Link, StaticQuery } from 'gatsby';

import CollectionTaxonomyLink from './collection-taxonomy-link';

import { CloseSvg } from '../common/svg';

import { preparedCollectionTaxonomyLabels } from '../../helpers/data-helpers';

import '../../styles/collections/collections-taxonomy-overlay.scss';

export default class CollectionsTaxonomyOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
      filter: 'All',
    }
  }

  render() {
    const mediaLabels = ['All', 'Images', 'Books', 'Film', 'Audio'];
    const taxonomyGroups = {
      'All': ['Epoch', 'Theme'],
      'Images': ['Epoch', 'Style', 'Theme'],
      'Books': ['Epoch', 'Genre', 'Theme', 'Type'],
      'Film': ['Epoch', 'Genre', 'Theme', 'Type'],
      'Audio': ['Epoch', 'Genre', 'Theme']
    };

    return (
      <StaticQuery
        query={graphql`
        {
          collections:allAirtable(filter:{table:{eq:"Collections"}, data:{Published: {eq: true}}}) {
            edges {
              node {
                data {
                  Medium
                  Epoch
                  Genre
                  Style
                  Theme
                  Type
                }
              }
            }
          }
        }
        `}
        render={data => {
          const filterLabels = {
            'All': {
              'Epoch': preparedCollectionTaxonomyLabels(data.collections, 'All', 'Epoch'),
              'Theme': preparedCollectionTaxonomyLabels(data.collections, 'All', 'Theme'),
            },
            'Images': {
              'Epoch': preparedCollectionTaxonomyLabels(data.collections, 'Images', 'Epoch'),
              'Style': preparedCollectionTaxonomyLabels(data.collections, 'Images', 'Style'),
              'Theme': preparedCollectionTaxonomyLabels(data.collections, 'Images', 'Theme'),
            },
            'Books': {
              'Epoch': preparedCollectionTaxonomyLabels(data.collections, 'Books', 'Epoch'),
              'Genre': preparedCollectionTaxonomyLabels(data.collections, 'Books', 'Genre'),
              'Theme': preparedCollectionTaxonomyLabels(data.collections, 'Books', 'Theme'),
              'Type': preparedCollectionTaxonomyLabels(data.collections, 'Books', 'Type'),
            },
            'Film': {
              'Epoch': preparedCollectionTaxonomyLabels(data.collections, 'Film', 'Epoch'),
              'Genre': preparedCollectionTaxonomyLabels(data.collections, 'Film', 'Genre'),
              'Theme': preparedCollectionTaxonomyLabels(data.collections, 'Film', 'Theme'),
              'Type': preparedCollectionTaxonomyLabels(data.collections, 'Film', 'Type'),
            },
            'Audio': {
              'Epoch': preparedCollectionTaxonomyLabels(data.collections, 'Audio', 'Epoch'),
              'Genre': preparedCollectionTaxonomyLabels(data.collections, 'Audio', 'Genre'),
              'Theme': preparedCollectionTaxonomyLabels(data.collections, 'Audio', 'Theme'),
            },
          };

          return (
            <>
              <button
                className="collections-taxonomy-overlay-launcher"
                onClick={ () => this.setState({ expanded: true }) }
              >
                + Filter Options
              </button>
              <div className={`collections-taxonomy-overlay ${(this.state.expanded) ? 'expanded' : ''}`}>
                <button
                  className="close-button"
                  onClick={() => this.setState({ expanded: false })}
                >
                  { CloseSvg }
                </button>

                <div className="filter-panels">
                  <div className="panel">
                    <div className="panel-header">
                      Browse Media
                    </div>
                    <div className="panel-options">
                      {mediaLabels.map((label, idx) => (
                        <button
                          key={`media-options-${idx}`}
                          className={`option ${(this.props.mediaContext === label) ? 'selected' : ''}`}
                          onClick={ () => this.props.handleTabClick(label) }
                        >
                          {label}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="panel">
                    <div className="panel-header">
                      Filtered By
                    </div>
                    <div className="panel-options">
                      <Link
                        className="option"
                        onClick={ () => this.setState({ expanded: false }) }
                        to={`/collections/${this.props.mediaContext.toLowerCase()}`}
                      >
                        All
                      </Link>
                      {taxonomyGroups[this.props.mediaContext].map((filter, idx) => (
                        <button
                          key={`filter-options-${idx}`}
                          className={`option ${(this.state.filter === filter) ? 'selected' : ''}`}
                          onClick={ () => this.setState({ filter: filter }) }
                        >
                          {filter}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
                {(filterLabels[this.props.mediaContext][this.state.filter]) ? (
                  <div className="taxonomy-links">
                    <p className="header">
                      Select {this.state.filter}
                    </p>
                    {filterLabels[this.props.mediaContext][this.state.filter].map((label, idx) => (
                      <CollectionTaxonomyLink
                        key={`taxonomy-link-${idx}`}
                        mediaGroup={ this.props.mediaContext }
                        taxon={ this.state.filter.toLowerCase() }
                        label={ label }
                      />
                    ))}
                  </div>
                ) : null}
              </div>
            </>
          );
        }}
      />
    );
  }
}